import { render, staticRenderFns } from "./handleHistory.vue?vue&type=template&id=960c0bcc&scoped=true"
import script from "./handleHistory.vue?vue&type=script&lang=js"
export * from "./handleHistory.vue?vue&type=script&lang=js"
import style0 from "./handleHistory.vue?vue&type=style&index=0&id=960c0bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960c0bcc",
  null
  
)

export default component.exports